/* tslint:disable */
/* eslint-disable */
/**
 * DIV.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CompanyDetailDto,
  CompanyDto,
  CompanyMetadataResponseDto,
  CompanyOverviewDtoFilterSortSearchPagedRequestDto,
  CompanyOverviewDtoPagedResponseDto,
  EntityNotFoundErrorDetailsErrorResponseModel,
  GetSpendingRequestDto,
  InvalidPropertyValueErrorDetailsErrorResponseModel,
  SpendingDto,
} from '../models/index';
import {
    CompanyDetailDtoFromJSON,
    CompanyDetailDtoToJSON,
    CompanyDtoFromJSON,
    CompanyDtoToJSON,
    CompanyMetadataResponseDtoFromJSON,
    CompanyMetadataResponseDtoToJSON,
    CompanyOverviewDtoFilterSortSearchPagedRequestDtoFromJSON,
    CompanyOverviewDtoFilterSortSearchPagedRequestDtoToJSON,
    CompanyOverviewDtoPagedResponseDtoFromJSON,
    CompanyOverviewDtoPagedResponseDtoToJSON,
    EntityNotFoundErrorDetailsErrorResponseModelFromJSON,
    EntityNotFoundErrorDetailsErrorResponseModelToJSON,
    GetSpendingRequestDtoFromJSON,
    GetSpendingRequestDtoToJSON,
    InvalidPropertyValueErrorDetailsErrorResponseModelFromJSON,
    InvalidPropertyValueErrorDetailsErrorResponseModelToJSON,
    SpendingDtoFromJSON,
    SpendingDtoToJSON,
} from '../models/index';

export interface CompaniesGetCompaniesByBoundingBoxGETRequest {
    minLat?: number;
    maxLat?: number;
    minLon?: number;
    maxLon?: number;
    categoriesEN?: string;
}

export interface CompaniesGetCompaniesByImportSessionGETRequest {
    importSessionId: string;
}

export interface CompaniesGetCompaniesOverviewPOSTRequest {
    companyOverviewDtoFilterSortSearchPagedRequestDto?: CompanyOverviewDtoFilterSortSearchPagedRequestDto;
}

export interface CompaniesGetCompanyBusinessUnitSpendingPOSTRequest {
    getSpendingRequestDto?: GetSpendingRequestDto;
}

export interface CompaniesGetCompanyByIdGETRequest {
    id: string;
}

export interface CompaniesGetCompanyCategorySpendingPOSTRequest {
    getSpendingRequestDto?: GetSpendingRequestDto;
}

export interface CompaniesGetCompanyMetadataGETRequest {
    year?: number;
}

export interface CompaniesGetCompanySingleGETRequest {
    companyId?: string;
}

/**
 * CompaniesApi - interface
 * 
 * @export
 * @interface CompaniesApiInterface
 */
export interface CompaniesApiInterface {
    /**
     * Creates request options for companiesGetCompaniesByBoundingBoxGET without sending the request
     * @param {number} [minLat] 
     * @param {number} [maxLat] 
     * @param {number} [minLon] 
     * @param {number} [maxLon] 
     * @param {string} [categoriesEN] 
     * @throws {RequiredError}
     * @memberof CompaniesApiInterface
     */
    companiesGetCompaniesByBoundingBoxGETRequestOpts(requestParameters: CompaniesGetCompaniesByBoundingBoxGETRequest): Promise<runtime.RequestOpts>;

    /**
     * 
     * @param {number} [minLat] 
     * @param {number} [maxLat] 
     * @param {number} [minLon] 
     * @param {number} [maxLon] 
     * @param {string} [categoriesEN] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompaniesApiInterface
     */
    companiesGetCompaniesByBoundingBoxGETRaw(requestParameters: CompaniesGetCompaniesByBoundingBoxGETRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<CompanyDto>>>;

    /**
     */
    companiesGetCompaniesByBoundingBoxGET(requestParameters: CompaniesGetCompaniesByBoundingBoxGETRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<CompanyDto>>;

    /**
     * Creates request options for companiesGetCompaniesByImportSessionGET without sending the request
     * @param {string} importSessionId 
     * @throws {RequiredError}
     * @memberof CompaniesApiInterface
     */
    companiesGetCompaniesByImportSessionGETRequestOpts(requestParameters: CompaniesGetCompaniesByImportSessionGETRequest): Promise<runtime.RequestOpts>;

    /**
     * 
     * @param {string} importSessionId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompaniesApiInterface
     */
    companiesGetCompaniesByImportSessionGETRaw(requestParameters: CompaniesGetCompaniesByImportSessionGETRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<CompanyDto>>>;

    /**
     */
    companiesGetCompaniesByImportSessionGET(requestParameters: CompaniesGetCompaniesByImportSessionGETRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<CompanyDto>>;

    /**
     * Creates request options for companiesGetCompaniesOverviewPOST without sending the request
     * @param {CompanyOverviewDtoFilterSortSearchPagedRequestDto} [companyOverviewDtoFilterSortSearchPagedRequestDto] 
     * @throws {RequiredError}
     * @memberof CompaniesApiInterface
     */
    companiesGetCompaniesOverviewPOSTRequestOpts(requestParameters: CompaniesGetCompaniesOverviewPOSTRequest): Promise<runtime.RequestOpts>;

    /**
     * 
     * @param {CompanyOverviewDtoFilterSortSearchPagedRequestDto} [companyOverviewDtoFilterSortSearchPagedRequestDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompaniesApiInterface
     */
    companiesGetCompaniesOverviewPOSTRaw(requestParameters: CompaniesGetCompaniesOverviewPOSTRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CompanyOverviewDtoPagedResponseDto>>;

    /**
     */
    companiesGetCompaniesOverviewPOST(requestParameters: CompaniesGetCompaniesOverviewPOSTRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CompanyOverviewDtoPagedResponseDto>;

    /**
     * Creates request options for companiesGetCompanyBusinessUnitSpendingPOST without sending the request
     * @param {GetSpendingRequestDto} [getSpendingRequestDto] 
     * @throws {RequiredError}
     * @memberof CompaniesApiInterface
     */
    companiesGetCompanyBusinessUnitSpendingPOSTRequestOpts(requestParameters: CompaniesGetCompanyBusinessUnitSpendingPOSTRequest): Promise<runtime.RequestOpts>;

    /**
     * 
     * @param {GetSpendingRequestDto} [getSpendingRequestDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompaniesApiInterface
     */
    companiesGetCompanyBusinessUnitSpendingPOSTRaw(requestParameters: CompaniesGetCompanyBusinessUnitSpendingPOSTRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<SpendingDto>>>;

    /**
     */
    companiesGetCompanyBusinessUnitSpendingPOST(requestParameters: CompaniesGetCompanyBusinessUnitSpendingPOSTRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<SpendingDto>>;

    /**
     * Creates request options for companiesGetCompanyByIdGET without sending the request
     * @param {string} id 
     * @throws {RequiredError}
     * @memberof CompaniesApiInterface
     */
    companiesGetCompanyByIdGETRequestOpts(requestParameters: CompaniesGetCompanyByIdGETRequest): Promise<runtime.RequestOpts>;

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompaniesApiInterface
     */
    companiesGetCompanyByIdGETRaw(requestParameters: CompaniesGetCompanyByIdGETRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CompanyDto>>;

    /**
     */
    companiesGetCompanyByIdGET(requestParameters: CompaniesGetCompanyByIdGETRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CompanyDto>;

    /**
     * Creates request options for companiesGetCompanyCategorySpendingPOST without sending the request
     * @param {GetSpendingRequestDto} [getSpendingRequestDto] 
     * @throws {RequiredError}
     * @memberof CompaniesApiInterface
     */
    companiesGetCompanyCategorySpendingPOSTRequestOpts(requestParameters: CompaniesGetCompanyCategorySpendingPOSTRequest): Promise<runtime.RequestOpts>;

    /**
     * 
     * @param {GetSpendingRequestDto} [getSpendingRequestDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompaniesApiInterface
     */
    companiesGetCompanyCategorySpendingPOSTRaw(requestParameters: CompaniesGetCompanyCategorySpendingPOSTRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<SpendingDto>>>;

    /**
     */
    companiesGetCompanyCategorySpendingPOST(requestParameters: CompaniesGetCompanyCategorySpendingPOSTRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<SpendingDto>>;

    /**
     * Creates request options for companiesGetCompanyMetadataGET without sending the request
     * @param {number} [year] 
     * @throws {RequiredError}
     * @memberof CompaniesApiInterface
     */
    companiesGetCompanyMetadataGETRequestOpts(requestParameters: CompaniesGetCompanyMetadataGETRequest): Promise<runtime.RequestOpts>;

    /**
     * 
     * @param {number} [year] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompaniesApiInterface
     */
    companiesGetCompanyMetadataGETRaw(requestParameters: CompaniesGetCompanyMetadataGETRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CompanyMetadataResponseDto>>;

    /**
     */
    companiesGetCompanyMetadataGET(requestParameters: CompaniesGetCompanyMetadataGETRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CompanyMetadataResponseDto>;

    /**
     * Creates request options for companiesGetCompanySingleGET without sending the request
     * @param {string} [companyId] 
     * @throws {RequiredError}
     * @memberof CompaniesApiInterface
     */
    companiesGetCompanySingleGETRequestOpts(requestParameters: CompaniesGetCompanySingleGETRequest): Promise<runtime.RequestOpts>;

    /**
     * 
     * @param {string} [companyId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompaniesApiInterface
     */
    companiesGetCompanySingleGETRaw(requestParameters: CompaniesGetCompanySingleGETRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CompanyDetailDto>>;

    /**
     */
    companiesGetCompanySingleGET(requestParameters: CompaniesGetCompanySingleGETRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CompanyDetailDto>;

}

/**
 * 
 */
export class CompaniesApi extends runtime.BaseAPI implements CompaniesApiInterface {

    /**
     * Creates request options for companiesGetCompaniesByBoundingBoxGET without sending the request
     */
    async companiesGetCompaniesByBoundingBoxGETRequestOpts(requestParameters: CompaniesGetCompaniesByBoundingBoxGETRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        if (requestParameters['minLat'] != null) {
            queryParameters['minLat'] = requestParameters['minLat'];
        }

        if (requestParameters['maxLat'] != null) {
            queryParameters['maxLat'] = requestParameters['maxLat'];
        }

        if (requestParameters['minLon'] != null) {
            queryParameters['minLon'] = requestParameters['minLon'];
        }

        if (requestParameters['maxLon'] != null) {
            queryParameters['maxLon'] = requestParameters['maxLon'];
        }

        if (requestParameters['categoriesEN'] != null) {
            queryParameters['categoriesEN'] = requestParameters['categoriesEN'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/Companies/boundingbox`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async companiesGetCompaniesByBoundingBoxGETRaw(requestParameters: CompaniesGetCompaniesByBoundingBoxGETRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<CompanyDto>>> {
        const requestOptions = await this.companiesGetCompaniesByBoundingBoxGETRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(CompanyDtoFromJSON));
    }

    /**
     */
    async companiesGetCompaniesByBoundingBoxGET(requestParameters: CompaniesGetCompaniesByBoundingBoxGETRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<CompanyDto>> {
        const response = await this.companiesGetCompaniesByBoundingBoxGETRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for companiesGetCompaniesByImportSessionGET without sending the request
     */
    async companiesGetCompaniesByImportSessionGETRequestOpts(requestParameters: CompaniesGetCompaniesByImportSessionGETRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['importSessionId'] == null) {
            throw new runtime.RequiredError(
                'importSessionId',
                'Required parameter "importSessionId" was null or undefined when calling companiesGetCompaniesByImportSessionGET().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/Companies/by-import-session/{importSessionId}`;
        urlPath = urlPath.replace(`{${"importSessionId"}}`, encodeURIComponent(String(requestParameters['importSessionId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async companiesGetCompaniesByImportSessionGETRaw(requestParameters: CompaniesGetCompaniesByImportSessionGETRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<CompanyDto>>> {
        const requestOptions = await this.companiesGetCompaniesByImportSessionGETRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(CompanyDtoFromJSON));
    }

    /**
     */
    async companiesGetCompaniesByImportSessionGET(requestParameters: CompaniesGetCompaniesByImportSessionGETRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<CompanyDto>> {
        const response = await this.companiesGetCompaniesByImportSessionGETRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for companiesGetCompaniesOverviewPOST without sending the request
     */
    async companiesGetCompaniesOverviewPOSTRequestOpts(requestParameters: CompaniesGetCompaniesOverviewPOSTRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/Companies/overview`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CompanyOverviewDtoFilterSortSearchPagedRequestDtoToJSON(requestParameters['companyOverviewDtoFilterSortSearchPagedRequestDto']),
        };
    }

    /**
     */
    async companiesGetCompaniesOverviewPOSTRaw(requestParameters: CompaniesGetCompaniesOverviewPOSTRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CompanyOverviewDtoPagedResponseDto>> {
        const requestOptions = await this.companiesGetCompaniesOverviewPOSTRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CompanyOverviewDtoPagedResponseDtoFromJSON(jsonValue));
    }

    /**
     */
    async companiesGetCompaniesOverviewPOST(requestParameters: CompaniesGetCompaniesOverviewPOSTRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CompanyOverviewDtoPagedResponseDto> {
        const response = await this.companiesGetCompaniesOverviewPOSTRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for companiesGetCompanyBusinessUnitSpendingPOST without sending the request
     */
    async companiesGetCompanyBusinessUnitSpendingPOSTRequestOpts(requestParameters: CompaniesGetCompanyBusinessUnitSpendingPOSTRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/Companies/business-unit-spending`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: GetSpendingRequestDtoToJSON(requestParameters['getSpendingRequestDto']),
        };
    }

    /**
     */
    async companiesGetCompanyBusinessUnitSpendingPOSTRaw(requestParameters: CompaniesGetCompanyBusinessUnitSpendingPOSTRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<SpendingDto>>> {
        const requestOptions = await this.companiesGetCompanyBusinessUnitSpendingPOSTRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(SpendingDtoFromJSON));
    }

    /**
     */
    async companiesGetCompanyBusinessUnitSpendingPOST(requestParameters: CompaniesGetCompanyBusinessUnitSpendingPOSTRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<SpendingDto>> {
        const response = await this.companiesGetCompanyBusinessUnitSpendingPOSTRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for companiesGetCompanyByIdGET without sending the request
     */
    async companiesGetCompanyByIdGETRequestOpts(requestParameters: CompaniesGetCompanyByIdGETRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling companiesGetCompanyByIdGET().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/Companies/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async companiesGetCompanyByIdGETRaw(requestParameters: CompaniesGetCompanyByIdGETRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CompanyDto>> {
        const requestOptions = await this.companiesGetCompanyByIdGETRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CompanyDtoFromJSON(jsonValue));
    }

    /**
     */
    async companiesGetCompanyByIdGET(requestParameters: CompaniesGetCompanyByIdGETRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CompanyDto> {
        const response = await this.companiesGetCompanyByIdGETRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for companiesGetCompanyCategorySpendingPOST without sending the request
     */
    async companiesGetCompanyCategorySpendingPOSTRequestOpts(requestParameters: CompaniesGetCompanyCategorySpendingPOSTRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/Companies/category-spending`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: GetSpendingRequestDtoToJSON(requestParameters['getSpendingRequestDto']),
        };
    }

    /**
     */
    async companiesGetCompanyCategorySpendingPOSTRaw(requestParameters: CompaniesGetCompanyCategorySpendingPOSTRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<SpendingDto>>> {
        const requestOptions = await this.companiesGetCompanyCategorySpendingPOSTRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(SpendingDtoFromJSON));
    }

    /**
     */
    async companiesGetCompanyCategorySpendingPOST(requestParameters: CompaniesGetCompanyCategorySpendingPOSTRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<SpendingDto>> {
        const response = await this.companiesGetCompanyCategorySpendingPOSTRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for companiesGetCompanyMetadataGET without sending the request
     */
    async companiesGetCompanyMetadataGETRequestOpts(requestParameters: CompaniesGetCompanyMetadataGETRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        if (requestParameters['year'] != null) {
            queryParameters['year'] = requestParameters['year'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/Companies/metadata`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async companiesGetCompanyMetadataGETRaw(requestParameters: CompaniesGetCompanyMetadataGETRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CompanyMetadataResponseDto>> {
        const requestOptions = await this.companiesGetCompanyMetadataGETRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CompanyMetadataResponseDtoFromJSON(jsonValue));
    }

    /**
     */
    async companiesGetCompanyMetadataGET(requestParameters: CompaniesGetCompanyMetadataGETRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CompanyMetadataResponseDto> {
        const response = await this.companiesGetCompanyMetadataGETRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for companiesGetCompanySingleGET without sending the request
     */
    async companiesGetCompanySingleGETRequestOpts(requestParameters: CompaniesGetCompanySingleGETRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        if (requestParameters['companyId'] != null) {
            queryParameters['companyId'] = requestParameters['companyId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/Companies/single`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async companiesGetCompanySingleGETRaw(requestParameters: CompaniesGetCompanySingleGETRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CompanyDetailDto>> {
        const requestOptions = await this.companiesGetCompanySingleGETRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CompanyDetailDtoFromJSON(jsonValue));
    }

    /**
     */
    async companiesGetCompanySingleGET(requestParameters: CompaniesGetCompanySingleGETRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CompanyDetailDto> {
        const response = await this.companiesGetCompanySingleGETRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
